package nl.volleyplanner.sportconfig

import kotlinx.datetime.LocalDate
import nl.volleyplanner.extensions.MonthDay
import nl.volleyplanner.extensions.getAge
import nl.volleyplanner.types.AgeGroup

open class SportConfig(
    val cutOffMonthDay: MonthDay,
    val ageGroups: Map<String, AgeGroup>
) {
    fun getPreviousCutOffDate(localDate: LocalDate): LocalDate {
        val year = if (MonthDay.from(localDate).isBefore(cutOffMonthDay)) { localDate.year - 1 } else { localDate.year }
        return cutOffMonthDay.atYear(year)
    }

    fun getAgeGroup(identifier: String) : AgeGroup {
        return ageGroups[identifier] ?: throw IllegalArgumentException("AgeGroup $identifier does not exist")
    }

    fun getAgeGroupAtDate(dateOfBirth: LocalDate, atDate: LocalDate): AgeGroup {
        return getAgeGroup(dateOfBirth.getAge(getPreviousCutOffDate(atDate)))!!
    }

    fun getAgeGroup(age: Int) : AgeGroup? {
        return ageGroups.values.find { it.ageFrom <= age && age < it.ageTo }
    }
}